import React from 'react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';
import classNames from 'classnames';
import DefaultImage from '@/assets/images/defaultImage.jpg';
import { Button } from '@/components/shared';
import { ImageResponse, ResourceLocation } from '@/generated/data.schemas';
import { Image } from '../Image';
import styles from './AvatarLink.module.scss';

interface AvatarLinkProps extends Partial<RouterLinkProps> {
	className?: string;
	image: Partial<ImageResponse>;
	linkTitle: string;
	linkUrl?: string;
	route?: ResourceLocation;
	onClick?: () => void;
	lazyLoading?: boolean;
}

export const AvatarLink: React.FunctionComponent<AvatarLinkProps> = ({
	className,
	image,
	linkTitle,
	linkUrl,
	to,
	route,
	onClick,
	lazyLoading,
}) => {
	const imageObj = {
		size180: image.size180 ? image.size180 : { url: DefaultImage },
		size320: image.size320 ? image.size320 : undefined,
		size480: image.size480 ? image.size480 : undefined,
		size720: image.size720 ? image.size720 : undefined,
		size960: image.size960 ? image.size960 : undefined,
		size1280: image.size1280 ? image.size1280 : undefined,
		size1920: image.size1920 ? image.size1920 : undefined,
	};

	return (
		<Button
			className={classNames(styles.clickArea, className)}
			hasNoStyles
			href={linkUrl}
			to={to}
			route={route}
			onClick={onClick}
		>
			<div className={styles.imageWrapper}>
				<Image
					className={styles.image}
					{...imageObj}
					altText={image.altText ?? linkTitle}
					responsiveSizesSettings={'100px'}
					lazyLoading={lazyLoading}
				/>
			</div>
			<span className={classNames(styles.linkTitle, 'u-ellipsis-2-lines')}>{linkTitle}</span>
		</Button>
	);
};
